import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/User';

const User = () => {
    const pagination = useSelector((state) => state.user.pagination);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs 
                parent="User" 
                title={pagination?.total ? `${pagination.total} Daftar Pengguna` : "Daftar Pengguna"} 
            />
            <DefaultContain />
        </Fragment>
    );
};
export default User;